module.exports = __webpack_public_path__ + "img/chevron-right.fcaf5c35.svg";